// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.personal-area {
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem;
  color: #fff;
  animation: slideIn 0.3s ease;
}

.loading-state,
.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 60vh;
  padding: 3rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.loading-icon {
  width: 48px;
  height: 48px;
  color: #00ff9f;
  margin-bottom: 1rem;
}

.spinning {
  animation: spin 2s linear infinite;
}

.personal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-icon {
  width: 48px;
  height: 48px;
  color: #00ff9f;
  filter: drop-shadow(0 0 10px rgba(0, 255, 162, 0.3));
}

.user-info h1 {
  margin: 0 0 0.5rem 0;
  font-size: 2rem;
  background: linear-gradient(135deg, #00ff9f, #00b8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.user-info p {
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
}

.header-actions {
  display: flex;
  gap: 1rem;
}

.qr-toggle-btn,
.refresh-btn,
.clear-btn,
.clear-data-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.qr-toggle-btn:hover,
.refresh-btn:hover,
.clear-btn:hover {
  border-color: #00ff9f;
  box-shadow: 0 0 20px rgba(0, 255, 162, 0.3);
  transform: translateY(-2px);
}

.qr-display {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
}

.qr-container {
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.qr-image {
  width: 200px;
  height: 200px;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.qr-container p {
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
  font-size: 1.1rem;
}

.download-qr-btn {
  background: linear-gradient(135deg, #00ff9f, #00b8ff);
  color: #000;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.download-qr-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 255, 162, 0.4);
}

.stats-overview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.stat-card {
  padding: 2rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 255, 162, 0.2);
}

.stat-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.stat-icon {
  width: 24px;
  height: 24px;
  color: #00ff9f;
}

.stat-header h3 {
  margin: 0;
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
}

.stat-value {
  font-size: 2.5rem;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.purchases-section {
  margin-bottom: 3rem;
}

.purchases-section h2 {
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
  color: #fff;
  text-align: center;
}

.purchases-list {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 1rem;
}

.purchase-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.purchase-item:last-child {
  border-bottom: none;
}

.purchase-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
}

.purchase-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.purchase-info strong {
  color: #fff;
  font-size: 1.1rem;
}

.purchase-quantity {
  color: #00ff9f;
  font-weight: 600;
  background: rgba(0, 255, 162, 0.1);
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.9rem;
}

.purchase-details {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
}

.purchase-price {
  color: #fff;
  font-weight: 600;
  font-size: 1.1rem;
}

.purchase-time {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8rem;
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  margin-bottom: 2rem;
}

.empty-state svg {
  color: rgba(255, 255, 255, 0.3);
  margin-bottom: 1rem;
}

.empty-state h3 {
  color: #fff;
  margin-bottom: 1rem;
}

.data-management {
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.clear-data-btn {
  background: rgba(255, 82, 82, 0.2);
  border-color: rgba(255, 82, 82, 0.3);
  color: #ff5252;
  margin-bottom: 1rem;
}

.clear-data-btn:hover {
  border-color: #ff5252;
  box-shadow: 0 0 20px rgba(255, 82, 82, 0.3);
}

.data-note {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
  margin: 0;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.4;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .personal-area {
    padding: 1rem;
  }
  
  .personal-header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .header-actions {
    justify-content: center;
  }
  
  .user-info h1 {
    font-size: 1.5rem;
  }
  
  .stats-overview {
    grid-template-columns: 1fr;
  }
  
  .purchase-item {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }
  
  .purchase-details {
    align-items: flex-start;
  }
  
  .qr-image {
    width: 150px;
    height: 150px;
  }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes slideIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}`, "",{"version":3,"sources":["webpack://./src/components/PersonalArea.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,WAAW;EACX,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;EAGE,qBAAqB;EACrB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":[".personal-area {\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 2rem;\n  color: #fff;\n  animation: slideIn 0.3s ease;\n}\n\n.loading-state,\n.error-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: 60vh;\n  padding: 3rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.loading-icon {\n  width: 48px;\n  height: 48px;\n  color: #00ff9f;\n  margin-bottom: 1rem;\n}\n\n.spinning {\n  animation: spin 2s linear infinite;\n}\n\n.personal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding: 1.5rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.user-icon {\n  width: 48px;\n  height: 48px;\n  color: #00ff9f;\n  filter: drop-shadow(0 0 10px rgba(0, 255, 162, 0.3));\n}\n\n.user-info h1 {\n  margin: 0 0 0.5rem 0;\n  font-size: 2rem;\n  background: linear-gradient(135deg, #00ff9f, #00b8ff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.user-info p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.header-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.qr-toggle-btn,\n.refresh-btn,\n.clear-btn,\n.clear-data-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 12px 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  color: #fff;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n}\n\n.qr-toggle-btn:hover,\n.refresh-btn:hover,\n.clear-btn:hover {\n  border-color: #00ff9f;\n  box-shadow: 0 0 20px rgba(0, 255, 162, 0.3);\n  transform: translateY(-2px);\n}\n\n.qr-display {\n  margin-bottom: 2rem;\n  display: flex;\n  justify-content: center;\n}\n\n.qr-container {\n  background: #fff;\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  text-align: center;\n}\n\n.qr-image {\n  width: 200px;\n  height: 200px;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n}\n\n.qr-container p {\n  color: #333;\n  margin-bottom: 1rem;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n.download-qr-btn {\n  background: linear-gradient(135deg, #00ff9f, #00b8ff);\n  color: #000;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 20px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.download-qr-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(0, 255, 162, 0.4);\n}\n\n.stats-overview {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n}\n\n.stat-card {\n  padding: 2rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 35px rgba(0, 255, 162, 0.2);\n}\n\n.stat-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.stat-icon {\n  width: 24px;\n  height: 24px;\n  color: #00ff9f;\n}\n\n.stat-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.stat-value {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #fff;\n  margin: 0;\n}\n\n.purchases-section {\n  margin-bottom: 3rem;\n}\n\n.purchases-section h2 {\n  margin-bottom: 1.5rem;\n  font-size: 1.8rem;\n  color: #fff;\n  text-align: center;\n}\n\n.purchases-list {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 1rem;\n}\n\n.purchase-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n}\n\n.purchase-item:last-child {\n  border-bottom: none;\n}\n\n.purchase-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n}\n\n.purchase-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.purchase-info strong {\n  color: #fff;\n  font-size: 1.1rem;\n}\n\n.purchase-quantity {\n  color: #00ff9f;\n  font-weight: 600;\n  background: rgba(0, 255, 162, 0.1);\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  font-size: 0.9rem;\n}\n\n.purchase-details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.25rem;\n}\n\n.purchase-price {\n  color: #fff;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n.purchase-time {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.8rem;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: rgba(255, 255, 255, 0.6);\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  margin-bottom: 2rem;\n}\n\n.empty-state svg {\n  color: rgba(255, 255, 255, 0.3);\n  margin-bottom: 1rem;\n}\n\n.empty-state h3 {\n  color: #fff;\n  margin-bottom: 1rem;\n}\n\n.data-management {\n  text-align: center;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.clear-data-btn {\n  background: rgba(255, 82, 82, 0.2);\n  border-color: rgba(255, 82, 82, 0.3);\n  color: #ff5252;\n  margin-bottom: 1rem;\n}\n\n.clear-data-btn:hover {\n  border-color: #ff5252;\n  box-shadow: 0 0 20px rgba(255, 82, 82, 0.3);\n}\n\n.data-note {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.9rem;\n  margin: 0;\n  max-width: 400px;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.4;\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .personal-area {\n    padding: 1rem;\n  }\n  \n  .personal-header {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n  \n  .header-actions {\n    justify-content: center;\n  }\n  \n  .user-info h1 {\n    font-size: 1.5rem;\n  }\n  \n  .stats-overview {\n    grid-template-columns: 1fr;\n  }\n  \n  .purchase-item {\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: flex-start;\n  }\n  \n  .purchase-details {\n    align-items: flex-start;\n  }\n  \n  .qr-image {\n    width: 150px;\n    height: 150px;\n  }\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@keyframes slideIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
